import Vue from 'vue'
import Vuex from 'vuex'
import Meta from 'vue-meta'
import ClientOnly from 'vue-client-only'
import NoSsr from 'vue-no-ssr'
import { createRouter } from './router.js'
import NuxtChild from './components/nuxt-child.js'
import NuxtError from './components/nuxt-error.vue'
import Nuxt from './components/nuxt.js'
import App from './App.js'
import { setContext, getLocation, getRouteData, normalizeError } from './utils'
import { createStore } from './store.js'

/* Plugins */

import nuxt_plugin_plugin_62607587 from 'nuxt_plugin_plugin_62607587' // Source: ./components/plugin.js (mode: 'all')
import nuxt_plugin_sentryserver_60ae743e from 'nuxt_plugin_sentryserver_60ae743e' // Source: ./sentry.server.js (mode: 'server')
import nuxt_plugin_sentryclient_69ef5459 from 'nuxt_plugin_sentryclient_69ef5459' // Source: ./sentry.client.js (mode: 'client')
import nuxt_plugin_plugin_a27b25a2 from 'nuxt_plugin_plugin_a27b25a2' // Source: ./composition-api/plugin.mjs (mode: 'all')
import nuxt_plugin_axios_06cd19c6 from 'nuxt_plugin_axios_06cd19c6' // Source: ./axios.js (mode: 'all')
import nuxt_plugin_yandexmetrikaplugin1743612c_3dc200f0 from 'nuxt_plugin_yandexmetrikaplugin1743612c_3dc200f0' // Source: ./yandex-metrika.plugin.1743612c.js (mode: 'client')
import nuxt_plugin_templatesplugin05e1394c_10c8d1e7 from 'nuxt_plugin_templatesplugin05e1394c_10c8d1e7' // Source: ./templates.plugin.05e1394c.js (mode: 'client')
import nuxt_plugin_cookieuniversalnuxt_dce98e76 from 'nuxt_plugin_cookieuniversalnuxt_dce98e76' // Source: ./cookie-universal-nuxt.js (mode: 'all')
import nuxt_plugin_passwordprotect_bfa40744 from 'nuxt_plugin_passwordprotect_bfa40744' // Source: ./password-protect.js (mode: 'all')
import nuxt_plugin_pluginutils_ad300e84 from 'nuxt_plugin_pluginutils_ad300e84' // Source: ./nuxt-i18n/plugin.utils.js (mode: 'all')
import nuxt_plugin_pluginrouting_b56562ee from 'nuxt_plugin_pluginrouting_b56562ee' // Source: ./nuxt-i18n/plugin.routing.js (mode: 'all')
import nuxt_plugin_pluginmain_29775cf4 from 'nuxt_plugin_pluginmain_29775cf4' // Source: ./nuxt-i18n/plugin.main.js (mode: 'all')
import nuxt_plugin_toast_6e6c8068 from 'nuxt_plugin_toast_6e6c8068' // Source: ./toast.js (mode: 'client')
import nuxt_plugin_moment_b57efbca from 'nuxt_plugin_moment_b57efbca' // Source: ./moment.js (mode: 'all')
import nuxt_plugin_pluginserver_9e54a802 from 'nuxt_plugin_pluginserver_9e54a802' // Source: ./color-mode/plugin.server.js (mode: 'server')
import nuxt_plugin_pluginclient_4b1c3a77 from 'nuxt_plugin_pluginclient_4b1c3a77' // Source: ./color-mode/plugin.client.js (mode: 'client')
import nuxt_plugin_elementui_d905880e from 'nuxt_plugin_elementui_d905880e' // Source: ../plugins/element-ui (mode: 'all')
import nuxt_plugin_zendesk_73eb44b1 from 'nuxt_plugin_zendesk_73eb44b1' // Source: ../plugins/zendesk.js (mode: 'client')
import nuxt_plugin_metaverse_5faad7c6 from 'nuxt_plugin_metaverse_5faad7c6' // Source: ../plugins/metaverse.js (mode: 'client')
import nuxt_plugin_broadcastchannel_23846f16 from 'nuxt_plugin_broadcastchannel_23846f16' // Source: ../plugins/broadcast-channel.js (mode: 'client')
import nuxt_plugin_vueclickoutside_68b86da3 from 'nuxt_plugin_vueclickoutside_68b86da3' // Source: ../plugins/vue-click-outside (mode: 'client')
import nuxt_plugin_popper_453487bc from 'nuxt_plugin_popper_453487bc' // Source: ../plugins/popper (mode: 'client')
import nuxt_plugin_hashids_1062c6b4 from 'nuxt_plugin_hashids_1062c6b4' // Source: ../plugins/hashids (mode: 'client')
import nuxt_plugin_web3_6a880fd5 from 'nuxt_plugin_web3_6a880fd5' // Source: ../plugins/web3 (mode: 'client')
import nuxt_plugin_bootstrapbundle_c77eafbc from 'nuxt_plugin_bootstrapbundle_c77eafbc' // Source: ../node_modules/bootstrap/dist/js/bootstrap.bundle.min (mode: 'client')
import nuxt_plugin_optinput_7719717a from 'nuxt_plugin_optinput_7719717a' // Source: ../plugins/opt-input (mode: 'all')
import nuxt_plugin_apexchart_b114e21e from 'nuxt_plugin_apexchart_b114e21e' // Source: ../plugins/apexchart.js (mode: 'client')
import nuxt_plugin_donutchart_e5ad46cc from 'nuxt_plugin_donutchart_e5ad46cc' // Source: ../plugins/donut-chart.js (mode: 'client')
import nuxt_plugin_vuegtag_44730e72 from 'nuxt_plugin_vuegtag_44730e72' // Source: ../plugins/vue-gtag.js (mode: 'client')
import nuxt_plugin_countryflag_a010fcc4 from 'nuxt_plugin_countryflag_a010fcc4' // Source: ../plugins/country-flag.js (mode: 'client')
import nuxt_plugin_globalmaker_0c5437e0 from 'nuxt_plugin_globalmaker_0c5437e0' // Source: ../plugins/global-maker (mode: 'client')
import nuxt_plugin_amCharts_04c8fd80 from 'nuxt_plugin_amCharts_04c8fd80' // Source: ../plugins/amCharts.js (mode: 'client')
import nuxt_plugin_apiService_6cf7f331 from 'nuxt_plugin_apiService_6cf7f331' // Source: ../plugins/apiService (mode: 'all')
import nuxt_plugin_toster_3898c2d8 from 'nuxt_plugin_toster_3898c2d8' // Source: ../plugins/toster.js (mode: 'client')
import nuxt_plugin_particles_1e1352c0 from 'nuxt_plugin_particles_1e1352c0' // Source: ../plugins/particles.js (mode: 'client')
import nuxt_plugin_cfturnstile_56147727 from 'nuxt_plugin_cfturnstile_56147727' // Source: ../plugins/cf-turnstile.js (mode: 'client')
import nuxt_plugin_vuetelinput_3f647bbc from 'nuxt_plugin_vuetelinput_3f647bbc' // Source: ../plugins/vue-tel-input.js (mode: 'client')
import nuxt_plugin_auth_4df0de73 from 'nuxt_plugin_auth_4df0de73' // Source: ./auth.js (mode: 'all')
import nuxt_plugin_nuxtjsauth_7535a704 from 'nuxt_plugin_nuxtjsauth_7535a704' // Source: ../plugins/nuxtjs-auth.js (mode: 'all')
import nuxt_plugin_meta_611c6ffe from 'nuxt_plugin_meta_611c6ffe' // Source: ./composition-api/meta.mjs (mode: 'all')

// Component: <ClientOnly>
Vue.component(ClientOnly.name, ClientOnly)

// TODO: Remove in Nuxt 3: <NoSsr>
Vue.component(NoSsr.name, {
  ...NoSsr,
  render (h, ctx) {
    if (process.client && !NoSsr._warned) {
      NoSsr._warned = true

      console.warn('<no-ssr> has been deprecated and will be removed in Nuxt 3, please use <client-only> instead')
    }
    return NoSsr.render(h, ctx)
  }
})

// Component: <NuxtChild>
Vue.component(NuxtChild.name, NuxtChild)
Vue.component('NChild', NuxtChild)

// Component NuxtLink is imported in server.js or client.js

// Component: <Nuxt>
Vue.component(Nuxt.name, Nuxt)

Object.defineProperty(Vue.prototype, '$nuxt', {
  get() {
    const globalNuxt = this.$root ? this.$root.$options.$nuxt : null
    if (process.client && !globalNuxt && typeof window !== 'undefined') {
      return window.$nuxt
    }
    return globalNuxt
  },
  configurable: true
})

Vue.use(Meta, {"keyName":"head","attribute":"data-n-head","ssrAttribute":"data-n-head-ssr","tagIDKeyName":"hid"})

const defaultTransition = {"name":"page","mode":"out-in","appear":true,"appearClass":"appear","appearActiveClass":"appear-active","appearToClass":"appear-to"}

const originalRegisterModule = Vuex.Store.prototype.registerModule

function registerModule (path, rawModule, options = {}) {
  const preserveState = process.client && (
    Array.isArray(path)
      ? !!path.reduce((namespacedState, path) => namespacedState && namespacedState[path], this.state)
      : path in this.state
  )
  return originalRegisterModule.call(this, path, rawModule, { preserveState, ...options })
}

async function createApp(ssrContext, config = {}) {
  const store = createStore(ssrContext)
  const router = await createRouter(ssrContext, config, { store })

  // Add this.$router into store actions/mutations
  store.$router = router

  // Create Root instance

  // here we inject the router and store to all child components,
  // making them available everywhere as `this.$router` and `this.$store`.
  const app = {
    head: {"title":"Affility","htmlAttrs":{"lang":"en"},"meta":[{"charset":"utf-8"},{"name":"viewport","content":"width=device-width, initial-scale=1, user-scalable=no"},{"hid":"description","name":"description","content":""},{"name":"format-detection","content":"telephone=no"}],"link":[{"rel":"icon","type":"image\u002Fx-icon","href":"\u002Ffavicon.ico"},{"href":"https:\u002F\u002Fmc.yandex.ru\u002Fmetrika\u002Ftag.js","rel":"preload","as":"script"}],"style":[],"script":[]},

    store,
    router,
    nuxt: {
      defaultTransition,
      transitions: [defaultTransition],
      setTransitions (transitions) {
        if (!Array.isArray(transitions)) {
          transitions = [transitions]
        }
        transitions = transitions.map((transition) => {
          if (!transition) {
            transition = defaultTransition
          } else if (typeof transition === 'string') {
            transition = Object.assign({}, defaultTransition, { name: transition })
          } else {
            transition = Object.assign({}, defaultTransition, transition)
          }
          return transition
        })
        this.$options.nuxt.transitions = transitions
        return transitions
      },

      err: null,
      dateErr: null,
      error (err) {
        err = err || null
        app.context._errored = Boolean(err)
        err = err ? normalizeError(err) : null
        let nuxt = app.nuxt // to work with @vue/composition-api, see https://github.com/nuxt/nuxt.js/issues/6517#issuecomment-573280207
        if (this) {
          nuxt = this.nuxt || this.$options.nuxt
        }
        nuxt.dateErr = Date.now()
        nuxt.err = err
        // Used in src/server.js
        if (ssrContext) {
          ssrContext.nuxt.error = err
        }
        return err
      }
    },
    ...App
  }

  // Make app available into store via this.app
  store.app = app

  const next = ssrContext ? ssrContext.next : location => app.router.push(location)
  // Resolve route
  let route
  if (ssrContext) {
    route = router.resolve(ssrContext.url).route
  } else {
    const path = getLocation(router.options.base, router.options.mode)
    route = router.resolve(path).route
  }

  // Set context to app.context
  await setContext(app, {
    store,
    route,
    next,
    error: app.nuxt.error.bind(app),
    payload: ssrContext ? ssrContext.payload : undefined,
    req: ssrContext ? ssrContext.req : undefined,
    res: ssrContext ? ssrContext.res : undefined,
    beforeRenderFns: ssrContext ? ssrContext.beforeRenderFns : undefined,
    beforeSerializeFns: ssrContext ? ssrContext.beforeSerializeFns : undefined,
    ssrContext
  })

  function inject(key, value) {
    if (!key) {
      throw new Error('inject(key, value) has no key provided')
    }
    if (value === undefined) {
      throw new Error(`inject('${key}', value) has no value provided`)
    }

    key = '$' + key
    // Add into app
    app[key] = value
    // Add into context
    if (!app.context[key]) {
      app.context[key] = value
    }

    // Add into store
    store[key] = app[key]

    // Check if plugin not already installed
    const installKey = '__nuxt_' + key + '_installed__'
    if (Vue[installKey]) {
      return
    }
    Vue[installKey] = true
    // Call Vue.use() to install the plugin into vm
    Vue.use(() => {
      if (!Object.prototype.hasOwnProperty.call(Vue.prototype, key)) {
        Object.defineProperty(Vue.prototype, key, {
          get () {
            return this.$root.$options[key]
          }
        })
      }
    })
  }

  // Inject runtime config as $config
  inject('config', config)

  if (process.client) {
    // Replace store state before plugins execution
    if (window.__NUXT__ && window.__NUXT__.state) {
      store.replaceState(window.__NUXT__.state)
    }
  }

  // Add enablePreview(previewData = {}) in context for plugins
  if (process.static && process.client) {
    app.context.enablePreview = function (previewData = {}) {
      app.previewData = Object.assign({}, previewData)
      inject('preview', previewData)
    }
  }
  // Plugin execution

  if (typeof nuxt_plugin_plugin_62607587 === 'function') {
    await nuxt_plugin_plugin_62607587(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_sentryserver_60ae743e === 'function') {
    await nuxt_plugin_sentryserver_60ae743e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_sentryclient_69ef5459 === 'function') {
    await nuxt_plugin_sentryclient_69ef5459(app.context, inject)
  }

  if (typeof nuxt_plugin_plugin_a27b25a2 === 'function') {
    await nuxt_plugin_plugin_a27b25a2(app.context, inject)
  }

  if (typeof nuxt_plugin_axios_06cd19c6 === 'function') {
    await nuxt_plugin_axios_06cd19c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_yandexmetrikaplugin1743612c_3dc200f0 === 'function') {
    await nuxt_plugin_yandexmetrikaplugin1743612c_3dc200f0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_templatesplugin05e1394c_10c8d1e7 === 'function') {
    await nuxt_plugin_templatesplugin05e1394c_10c8d1e7(app.context, inject)
  }

  if (typeof nuxt_plugin_cookieuniversalnuxt_dce98e76 === 'function') {
    await nuxt_plugin_cookieuniversalnuxt_dce98e76(app.context, inject)
  }

  if (typeof nuxt_plugin_passwordprotect_bfa40744 === 'function') {
    await nuxt_plugin_passwordprotect_bfa40744(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginutils_ad300e84 === 'function') {
    await nuxt_plugin_pluginutils_ad300e84(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginrouting_b56562ee === 'function') {
    await nuxt_plugin_pluginrouting_b56562ee(app.context, inject)
  }

  if (typeof nuxt_plugin_pluginmain_29775cf4 === 'function') {
    await nuxt_plugin_pluginmain_29775cf4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toast_6e6c8068 === 'function') {
    await nuxt_plugin_toast_6e6c8068(app.context, inject)
  }

  if (typeof nuxt_plugin_moment_b57efbca === 'function') {
    await nuxt_plugin_moment_b57efbca(app.context, inject)
  }

  if (process.server && typeof nuxt_plugin_pluginserver_9e54a802 === 'function') {
    await nuxt_plugin_pluginserver_9e54a802(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_pluginclient_4b1c3a77 === 'function') {
    await nuxt_plugin_pluginclient_4b1c3a77(app.context, inject)
  }

  if (typeof nuxt_plugin_elementui_d905880e === 'function') {
    await nuxt_plugin_elementui_d905880e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_zendesk_73eb44b1 === 'function') {
    await nuxt_plugin_zendesk_73eb44b1(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_metaverse_5faad7c6 === 'function') {
    await nuxt_plugin_metaverse_5faad7c6(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_broadcastchannel_23846f16 === 'function') {
    await nuxt_plugin_broadcastchannel_23846f16(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vueclickoutside_68b86da3 === 'function') {
    await nuxt_plugin_vueclickoutside_68b86da3(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_popper_453487bc === 'function') {
    await nuxt_plugin_popper_453487bc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_hashids_1062c6b4 === 'function') {
    await nuxt_plugin_hashids_1062c6b4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_web3_6a880fd5 === 'function') {
    await nuxt_plugin_web3_6a880fd5(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_bootstrapbundle_c77eafbc === 'function') {
    await nuxt_plugin_bootstrapbundle_c77eafbc(app.context, inject)
  }

  if (typeof nuxt_plugin_optinput_7719717a === 'function') {
    await nuxt_plugin_optinput_7719717a(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_apexchart_b114e21e === 'function') {
    await nuxt_plugin_apexchart_b114e21e(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_donutchart_e5ad46cc === 'function') {
    await nuxt_plugin_donutchart_e5ad46cc(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuegtag_44730e72 === 'function') {
    await nuxt_plugin_vuegtag_44730e72(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_countryflag_a010fcc4 === 'function') {
    await nuxt_plugin_countryflag_a010fcc4(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_globalmaker_0c5437e0 === 'function') {
    await nuxt_plugin_globalmaker_0c5437e0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_amCharts_04c8fd80 === 'function') {
    await nuxt_plugin_amCharts_04c8fd80(app.context, inject)
  }

  if (typeof nuxt_plugin_apiService_6cf7f331 === 'function') {
    await nuxt_plugin_apiService_6cf7f331(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_toster_3898c2d8 === 'function') {
    await nuxt_plugin_toster_3898c2d8(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_particles_1e1352c0 === 'function') {
    await nuxt_plugin_particles_1e1352c0(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_cfturnstile_56147727 === 'function') {
    await nuxt_plugin_cfturnstile_56147727(app.context, inject)
  }

  if (process.client && typeof nuxt_plugin_vuetelinput_3f647bbc === 'function') {
    await nuxt_plugin_vuetelinput_3f647bbc(app.context, inject)
  }

  if (typeof nuxt_plugin_auth_4df0de73 === 'function') {
    await nuxt_plugin_auth_4df0de73(app.context, inject)
  }

  if (typeof nuxt_plugin_nuxtjsauth_7535a704 === 'function') {
    await nuxt_plugin_nuxtjsauth_7535a704(app.context, inject)
  }

  if (typeof nuxt_plugin_meta_611c6ffe === 'function') {
    await nuxt_plugin_meta_611c6ffe(app.context, inject)
  }

  // Lock enablePreview in context
  if (process.static && process.client) {
    app.context.enablePreview = function () {
      console.warn('You cannot call enablePreview() outside a plugin.')
    }
  }

  // Wait for async component to be resolved first
  await new Promise((resolve, reject) => {
    // Ignore 404s rather than blindly replacing URL in browser
    if (process.client) {
      const { route } = router.resolve(app.context.route.fullPath)
      if (!route.matched.length) {
        return resolve()
      }
    }
    router.replace(app.context.route.fullPath, resolve, (err) => {
      // https://github.com/vuejs/vue-router/blob/v3.4.3/src/util/errors.js
      if (!err._isRouter) return reject(err)
      if (err.type !== 2 /* NavigationFailureType.redirected */) return resolve()

      // navigated to a different route in router guard
      const unregister = router.afterEach(async (to, from) => {
        if (process.server && ssrContext && ssrContext.url) {
          ssrContext.url = to.fullPath
        }
        app.context.route = await getRouteData(to)
        app.context.params = to.params || {}
        app.context.query = to.query || {}
        unregister()
        resolve()
      })
    })
  })

  return {
    store,
    app,
    router
  }
}

export { createApp, NuxtError }
